"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Numeric = exports.EventTypes = void 0;
var EventTypes = exports.EventTypes = {
  Intersection: "Visualization/Intersection",
  ClickAway: "Visualization/ClickAway",
  ModelLoaded: "Visualization/ModelLoaded",
  MaterialUpdated: "Visualization/MaterialUpdated",
  Error: "Visualization/Error",
  Initialized: "Visualization/Initialized",
  LoadStart: "Visualization/LoadStart",
  LoadFinished: "Visualization/LoadFinished",
  LoadError: "Visualization/LoadError",
  EmptySceneError: "Visualization/EmptySceneError",
  Zoomed: "Visualization/Zoomed",
  HoverIn: "Visualization/HoverIn",
  HoverOut: "Visualization/HoverOut"
};
var Numeric = exports.Numeric = {
  TwoPI: 2 * Math.PI
};